interface InvitationPageHeaderProps {
  title: string;
  subtitle: string;
}

export function InvitationPageHeader({
  title,
  subtitle,
}: InvitationPageHeaderProps) {
  return (
    <div className="flex flex-col lg:flex-row items-center justify-between gap-4 w-full mb-8">
      <div className="flex flex-col lg:flex-row items-center gap-4">
        <img src="/logo.svg" alt="Logo" className="h-8 lg:h-12 w-auto" />
        <div className="flex flex-col items-center lg:items-start gap-1">
          <h1 className="text-xl lg:text-2xl font-bold text-foreground text-center lg:text-left">
            {title}
          </h1>
          <p className="text-xs lg:text-sm text-gray-500 text-center lg:text-left">
            {subtitle}
          </p>
        </div>
      </div>
    </div>
  );
}
